"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FaqTemplate1;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FaqTemplate1(props) {
  var _state$section, _state$section$sectio, _state$section2, _state$section2$quest, _state$section2$quest2;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  const [expandedSection, setExapnsionSection] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  const toggleExpandedSection = questionIndex => {
    if (expandedSection[questionIndex]) setExapnsionSection({});else setExapnsionSection({
      [questionIndex]: true
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "faq-template-1-container w-100 flex flex-column items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "f3 fw6 heading"
  }, state === null || state === void 0 ? void 0 : (_state$section = state.section) === null || _state$section === void 0 ? void 0 : (_state$section$sectio = _state$section.section_title) === null || _state$section$sectio === void 0 ? void 0 : _state$section$sectio.display_text), state !== null && state !== void 0 && (_state$section2 = state.section) !== null && _state$section2 !== void 0 && (_state$section2$quest = _state$section2.questions_list) !== null && _state$section2$quest !== void 0 && (_state$section2$quest2 = _state$section2$quest.list) !== null && _state$section2$quest2 !== void 0 && _state$section2$quest2.length ? state.section.questions_list.list.map((question, index) => {
    var _question$question_te, _question$question_de;

    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "question-box relative w-100",
      onClick: () => toggleExpandedSection(index)
    }, question !== null && question !== void 0 && (_question$question_te = question.question_text) !== null && _question$question_te !== void 0 && _question$question_te.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      className: "f4 b question-title flex items-center justify-between ".concat(expandedSection[index] ? "show-border" : "")
    }, /*#__PURE__*/_react.default.createElement("span", null, question.question_text.display_text), expandedSection[index] ? /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/longtail/addpages/ic-minus-red.svg",
      alt: ""
    }) : /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/longtail/addpages/ic-red-plus.svg",
      alt: ""
    })) : null, expandedSection[index] && question !== null && question !== void 0 && (_question$question_de = question.question_description) !== null && _question$question_de !== void 0 && _question$question_de.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      className: "f5 question-desc"
    }, question.question_description.display_text) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer flex relative items-center",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "questions_list",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: "",
          operation: "delete"
        });
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove"), /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "questions_list",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: ""
        });
      }
    }, "Edit")));
  }) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-btn flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "questions_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, "+ Add New FAQ"));
}